import type { ButtonPropSize, ButtonPropView } from 'uikit';
import { Button, DragNDropField } from 'uikit';

import cn from 'classnames';

import styles from './FilesSelectorButton.module.css';

interface IFilesSelectorButton {
    onDropFiles: (files: File[]) => void;
    label?: string;
    accept?: string | string[];
    view?: ButtonPropView;
    size?: ButtonPropSize;
    isDisabled?: boolean;
    isLoading?: boolean;
}

export const FilesSelectorButton = ({
    label,
    view,
    size,
    accept,
    isDisabled,
    isLoading,
    onDropFiles,
}: IFilesSelectorButton) => (
    <DragNDropField
        accept={accept}
        onDropFiles={onDropFiles}
        disabled={isLoading || isDisabled}
        className={cn(styles.container, {
            [styles.containerDisable]: isLoading,
        })}
    >
        {({ openFileDialog }) => (
            <div className="selectorBody">
                <Button
                    onClick={openFileDialog}
                    label={label || 'Выберите файл'}
                    view={view}
                    disabled={isDisabled}
                    size={size}
                    loading={isLoading}
                />
            </div>
        )}
    </DragNDropField>
);

FilesSelectorButton.displayName = 'FilesSelectorButton';
